import { render } from "./CollectionCardForgeBlock.vue?vue&type=template&id=962ac21c"
import script from "./CollectionCardForgeBlock.vue?vue&type=script&lang=js"
export * from "./CollectionCardForgeBlock.vue?vue&type=script&lang=js"

import "./CollectionCardForgeBlock.vue?vue&type=style&index=0&id=962ac21c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__